import { css, styled } from "@mui/material";

export const Container = styled("div")(({ theme }) => {
  return css`
    display: none;
    position: absolute;
    margin-right: ${theme.spacing(2)};
    text-shadow: ${theme.textShadows[2]};
    opacity: 0.8;
    z-index: ${theme.zIndex.mobileStepper - 75};
    transform: translateY(50%);
    animation: pulseOpacity 3s ease-in-out infinite;

    ${theme.breakpoints.up("md")} {
      display: block;
    }
  `;
});
